import { Chain } from '@ankr.com/chains-list';
import { t } from '@ankr.com/common';
import { useMemo } from 'react';

import { AccountPermission } from 'modules/permissions/constants';
import { ChainProjectsSection } from 'domains/chains/screens/ChainPage/components/ChainProjectsSection';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { H1Tag } from 'uiKit/H1Tag';
import { StatisticsWidget } from 'modules/chains/components/StatisticsWidget';
import { getChainName } from 'uiKit/utils/metatags';

import { AAPIBenefits } from '../AAPIBenefits';
import { AAPIEndpointsWidget } from '../AAPIEndpointsWidget';
import { AAPIInfoTabs } from '../AAPIInfoTabs';

interface PrivateAAPIPageContentProps {
  chain: Chain;
}

export const PrivateAAPIPageContent = ({
  chain,
}: PrivateAAPIPageContentProps) => {
  const chainName = useMemo(() => getChainName(chain.id), [chain.id]);

  return (
    <>
      <H1Tag title={t('meta.chain-item.h1-tag', { chainId: chainName })} />
      <AAPIEndpointsWidget chain={chain} />
      <GuardAccountPermission permission={AccountPermission.JwtManagerRead}>
        <ChainProjectsSection chain={chain} />
      </GuardAccountPermission>
      <AAPIInfoTabs />
      <AAPIBenefits />
      <StatisticsWidget chain={chain} />
    </>
  );
};
